module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAjCAMAAADYDBjmAAAAclBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9eWEHEAAAAJXRSTlMAYgp1YYvmJRnHn5SAdykeEergeGpYTDUjHA0G9fHKvrWqQzABXRhXXwAAAKNJREFUOMvt1MsOgjAQheHTchOEljsC3rXv/4q2ERNdCIet8d/M5ltMMsnApVsh/JmEf83xTMeGKJHOKkNm9WjYSqA2dAoxj1OEPN6i4HEAw3dCI9jqDj+fHCTZMMLwJdivOXfI4+CPOez1mymdLuEEb8UTLr7gywdeWiOLdpHLjuB17uOav5Hx+AZJ2wOAjsU5bKpk6Nla1z1qqsybqfLa3sEHgAmaiU1uXYwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu2_3.png
// module id = WNzj
// module chunks = 1